import React from 'react';
import {object, func, string, number, oneOfType} from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import SecondaryButton from 'dibs-elements/dist/Button/Secondary';
import 'dibs-elements/dist/Button/buyer/Secondary.css';
import {AUTH_CLICK_LOGIN, AUTH_CLICK_REGISTER, AUTH_CLICK_LOGOUT} from '../utils/mobileNavConstants.js';
import styles from './mobileNavAuthButtonsStyles.scss';
import copy from './MobileNavAuthButtonsCopy';

function Button(props) {
    return (
        <SecondaryButton size="medium" className={styles.button} onClick={() => props.onAuthClick(props.clickAction)}>
            {props.text}
        </SecondaryButton>
    );
}

Button.propTypes = {
    text: string.isRequired,
    onAuthClick: func.isRequired,
    clickAction: oneOfType([number, string])
};

export function MobileNavAuthButtons(props) {
    if (props.user) {
        return (
            <div className={styles.container}>
                <Button text={copy.logout} onAuthClick={props.onAuthClick} clickAction={AUTH_CLICK_LOGOUT} />
            </div>
        );
    } else {
        return (
            <div className={styles.container}>
                <Button text={copy.login} onAuthClick={props.onAuthClick} clickAction={AUTH_CLICK_LOGIN} />
                <Button text={copy.register} onAuthClick={props.onAuthClick} clickAction={AUTH_CLICK_REGISTER} />
            </div>
        );
    }
}

export default createFragmentContainer(MobileNavAuthButtons, graphql`
    fragment MobileNavAuthButtons_user on User {
        serviceId
    }
`);

MobileNavAuthButtons.propTypes = {
    onAuthClick: func.isRequired,
    user: object
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavAuthButtons/MobileNavAuthButtons.jsx